import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { IStatefulOptions } from 'src/app/core/interfaces/onboarding/page-state/stateful-options.interface';
import { RequestObserverService } from 'src/app/core/services/common/request-observer.service';

@Component({
  selector: 'app-stateful-answer-button-list',
  templateUrl: './stateful-answer-button-list.component.html',
  styleUrls: ['./stateful-answer-button-list.component.scss'],
})
export class StatefulAnswerButtonListComponent implements AfterViewInit {
  @Input() options: IStatefulOptions[];
  @Input() clickEvent: () => Promise<unknown>;
  @Input() cssClass: 'grid' | 'stack' = 'stack';
  @Input() bypassNav = false;
  @Output() outputParameter: EventEmitter<any> = new EventEmitter<any>();
  recentlySelected = false;
  selectedIndex = -1;
  disabled = false;

  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'secondary',
    size: <LoaderSize>'small',
  };

  constructor(
    private router: Router,
    private requestObserver: RequestObserverService
  ) {}

  ngAfterViewInit() {
    if (this.options === undefined) return;
    for (let i = 0; i < this.options.length; i += 1) {
      if (this.options[i].selected === true) {
        this.selectedIndex = i;
        break;
      }
    }
  }

  async submit(index: number) {
    this.disabled = true;
    if (this.selectedIndex !== -1) {
      this.options[this.selectedIndex].selected = false;
    }

    this.selectedIndex = index;
    const selectedPageState = this.options[index].state;
    this.options[index].selected = true;
    this.recentlySelected = true;
    this.outputParameter.emit(this.selectedIndex);
    if (this.clickEvent !== undefined) {
      const shouldProceed = await this.clickEvent();
      if (!shouldProceed) {
        this.options[index].selected = false;
        this.recentlySelected = false;
        this.disabled = false;
        return false;
      }
    }
    if (!this.bypassNav) {
      await this.navigate(selectedPageState);
    }
    return true;
  }

  async navigate(pageState: any) {
    await this.router.navigate([pageState.pageUrl], {
      queryParams: { stateId: pageState.id },
    });
  }
}
